import React, { useState } from 'react';
import { auth, db } from '../firebase/config';
import { updatePassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';

// Shown when an admin has set a temporary password. The person cannot reach the
// rest of the portal until they choose their own.
export default function ForcePasswordChange({ user, onDone }) {
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async (e) => {
    e.preventDefault();
    setError('');
    if (pw.length < 8) { setError('Use at least 8 characters.'); return; }
    if (pw !== confirm) { setError('Those two passwords do not match.'); return; }
    setSaving(true);
    try {
      await updatePassword(auth.currentUser, pw);
      await setDoc(doc(db, 'users', user.uid), { mustChangePassword: false }, { merge: true });
      onDone();
    } catch (err) {
      // Firebase requires a recent sign-in before a password change.
      if (err?.code === 'auth/requires-recent-login') {
        setError('For security, please sign out and sign back in with your temporary password, then try again.');
      } else {
        setError(err?.message || 'Could not update your password. Please try again.');
      }
    }
    setSaving(false);
  };

  return (
    <div style={s.screen}>
      <form style={s.box} onSubmit={handleSave}>
        <div style={s.logo}>The Corporate <span style={{ color: '#E87166' }}>Fixers</span></div>
        <div style={s.title}>Choose your password</div>
        <p style={s.sub}>
          You signed in with a temporary password. Pick your own now and you will use it from here on.
        </p>

        <label style={s.label}>New password</label>
        <input style={s.input} type="password" value={pw} onChange={e => setPw(e.target.value)} placeholder="At least 8 characters" autoFocus />

        <label style={s.label}>Type it again</label>
        <input style={s.input} type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Confirm your password" />

        {error && <div style={s.error}>{error}</div>}

        <button style={s.btn} type="submit" disabled={saving}>
          {saving ? 'Saving...' : 'Save and continue'}
        </button>
      </form>
    </div>
  );
}

const s = {
  screen: { minHeight: '100vh', background: '#1B2A4A', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: 'DM Sans, sans-serif' },
  box: { background: '#FFFFFF', padding: '36px 40px', maxWidth: '420px', width: '100%', borderTop: '4px solid #D4A847' },
  logo: { fontFamily: 'Playfair Display, serif', fontSize: '18px', fontWeight: '700', color: '#1B2A4A', marginBottom: '20px' },
  title: { fontFamily: 'Playfair Display, serif', fontSize: '24px', fontWeight: '900', color: '#1B2A4A', marginBottom: '8px' },
  sub: { fontSize: '13px', color: '#3D3D3D', lineHeight: 1.6, fontWeight: '300', marginBottom: '20px' },
  label: { display: 'block', fontSize: '11px', fontWeight: '600', color: '#1B2A4A', letterSpacing: '0.4px', textTransform: 'uppercase', margin: '14px 0 5px' },
  input: { width: '100%', border: '1.5px solid #E8E6E2', padding: '11px 14px', fontFamily: 'DM Sans, sans-serif', fontSize: '14px', color: '#3D3D3D', background: '#FAF8F5', outline: 'none', boxSizing: 'border-box' },
  error: { background: '#fdecea', color: '#a32d2d', padding: '10px 14px', fontSize: '12.5px', marginTop: '14px', lineHeight: 1.5 },
  btn: { width: '100%', background: '#1B2A4A', color: '#fff', border: 'none', padding: '13px', fontSize: '14px', fontWeight: '700', cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', marginTop: '20px' },
};
